import { AnyAction, AsyncThunk, AsyncThunkPayloadCreator, Draft, createAsyncThunk } from '@reduxjs/toolkit';
import { OptionsObject } from 'notistack';
import { TypedUseSelectorHook, useSelector as reduxSelector, useDispatch } from 'react-redux';
import { ActionType } from 'typesafe-actions';
import store, { createRootReducer } from '../store';
import { IAuthState } from '../store/auth/reducer';
import dataActions from '../store/data/actions';
import { IDataState } from '../store/data/reducer';
import fileActions from '../store/file/actions';
import { IFileState } from '../store/file/reducer';
import { IGeneralState } from '../store/general/reducer';

// eslint-disable-next-line no-unused-vars
export type DispatchCall<P> = (payload : P) => void;
export type DispatchCallEmpty = () => void;

export interface INotification {
    message : string | React.ReactNode;
    options ?: Draft<OptionsObject>;
}

export interface ISnackbarNotification extends INotification {
    key : number;
}

export type RootState = ReturnType<typeof createRootReducer>;

export interface IRootState {
    auth : IAuthState;
    general : IGeneralState;
    data : IDataState;
    file : IFileState;
}

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector : TypedUseSelectorHook<RootState> = reduxSelector;

export type payloadCreator<Returned, ThunkArg> = AsyncThunkPayloadCreator<Returned, ThunkArg, ThunkConfig>;
export declare function AppAsyncThunk<Returned = void, ThunkArg = void>(typePrefix : string, payloadCreator : payloadCreator<Returned, ThunkArg>) : AsyncThunk<Returned, ThunkArg, ThunkConfig>;
export const createAppAsyncThunk : typeof AppAsyncThunk = (typePrefix : string, payloadCreator) => createAsyncThunk(typePrefix, payloadCreator);


interface ThunkConfig {
    state : RootState;
}

export type ThunkApi = {
    dispatch : AppDispatch;
    state : RootState;
};

export type DataAction = ActionType<typeof dataActions>;
export type FileAction = ActionType<typeof fileActions>;

export type RootAction =
    | AnyAction
    | DataAction
    | FileAction;
